import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
export default {
  name: 'VideoPlayer',
  data: function data() {
    return {
      // 视频数据（与新闻标签页的newsTags对应）
      videoList: [{
        id: 1,
        title: "输血的前世今生（第一集）",
        desc: "第一集：从神话到医学——血液的神秘起源",
        // desc: " 200 多种活性成分，尚无真正可替代的人造血液。且保存时间短，红细胞仅 35 天，血小板仅 5 天，需健康人群定期捐献维持血库平衡。这体现社会共济。谁都可能是需血者，献血是为社会织 “生命安全网”。一个国家无偿献血率达 10‰以上，才能基本满足临床用血需求。科学证明，健康成人一次献血 200-400 毫升，占全身血液 5%-10%，身体会快速恢复。此刻，超 100 万患者等输血。你的一袋血，可能延续生命，这是无偿献血最温暖的意义。",
        videoUrl: "/images/blood-donation1.mp4" // 对应public/videos目录下的视频

      }, {
        id: 2,
        title: "输血的前世今生（第二集）",
        desc: "第二集：从动物到人类——输血实验的疯狂年代",
        // desc: "很多人会有这样的疑问：献血是无偿的，为什么到了医院用血还要收费？其实这背后藏着关于血液安全的科学逻辑。首先要明确的是，血液本身是免费的。我国《献血法》明确规定，无偿献血的血液必须用于临床，严禁买卖。推行无偿献血，正是为了杜绝血液商品化带来的安全隐患——如果血液可以交易，就可能有人为利益隐瞒传染病史，让受血者面临二次风险。而所谓的“用血收费”，实际是血液处理过程中的成本费用。从献血者伸出手臂到血液输入患者体内，要经过一系列复杂环节：采血时使用的一次性血袋、针头是专用耗材；每袋血液需要进行乙肝、丙肝、艾滋病等多项传染病检测，仅核酸检测就需经过至少两次复核；红细胞、血浆、血小板等不同成分，还需在特定温度下分离、储存和运输——红细胞需4℃冷藏，血小板要22℃恒温振荡保存，这些都需要专业设备和持续能耗。这些费用仅用于覆盖采集、检测、储存、运输等必要成本，而非血液本身的价格。而且，无偿献血者及其亲属还能享受费用减免：本人献血后，可按规定免交相应的用血成本费；亲属用血也能获得不同程度的费用报销，这正是“人人为我，我为人人”的体现。无偿献血是社会共济的纽带，而合理的成本收费是保障血液安全的必要支撑。每一次献血，都是在为生命安全网添砖加瓦。当更多人加入无偿献血的行列，这份爱心就能通过规范的流程，传递给每一个需要的人。",
        videoUrl: "/images/blood-donation2.mp4"
      }, {
        id: 3,
        title: "输血的前世今生（第三集）",
        desc: "第三集：从战争到血库——现代输血的逆袭之路",
        videoUrl: "/images/blood-donation3.mp4"
      }, {
        id: 4,
        title: "血型的秘密",
        desc: "嘿！你知道吗？每个人的血液里都藏着两套“生命密码”，今天用4分钟带你拆解血型的秘密，看完记得查血型报告，关键时刻能救命！",
        videoUrl: "/images/blood-donation4.mp4"
      }, {
        id: 5,
        title: "6．14献血者日",
        desc: "热血传递希望，携手挽救生命",
        videoUrl: "/images/blood-donation5.mp4"
      }, {
        id: 6,
        title: "为什么全世界都在推行无偿献血",
        desc: "为什么全世界都在推行无偿献血？一个关于生命的奇妙问答，背后藏着硬核逻辑与生命守护。",
        videoUrl: "/images/blood-donation6.mp4"
      }, {
        id: 7,
        title: "为什么献血无偿用血收费",
        desc: "献血无偿，为什么用血时却要付费呢？揭秘血液背后的“隐藏账单”",
        videoUrl: "/images/blood-donation7.mp4"
      }, {
        id: 8,
        title: "为什么难以落实优先用血",
        desc: "明明献过好几次血，真到用血时却被通知“血库空了”，甚至还得让家属补献，说好的优先用血呢？别急，今天咱们就来扒一扒这背后的原因！",
        videoUrl: "/images/blood-donation8.mp4"
      }, {
        id: 9,
        title: "互助献血为何被叫停",
        desc: "小伙伴们，今天来聊个有点特别的话题——“互助献血”。病人要用血，家属得先献血，看似公平却引发许多问题！2018年国家卫健委把互助献血叫停，这里面的门道，咱们一个个说清楚！",
        videoUrl: "/images/blood-donation9.mp4"
      }, {
        id: 10,
        title: "献血对身体有哪些影响",
        desc: "大家经常听到宣传语——“献血可以促进造血能力、可以降血脂、可以降血压”这种表述不准确！今天小编就从科学角度给大家分析分析献血对身体带来的影响有哪些",
        videoUrl: "/images/blood-donation10.mp4"
      }, {
        id: 11,
        title: "献血需要多久恢复",
        desc: "献血，一份爱心，拯救生命。献完血后，你的身体需要多久才能完全恢复呢？ ",
        videoUrl: "/images/blood-donation11.mp4"
      }, {
        id: 12,
        title: "什么是献血间隔期",
        desc: "什么是献血间隔期？科学认识献血，守护生命健康。",
        videoUrl: "/images/blood-donation12.mp4"
      }],
      currentVideo: {},
      // 当前播放的视频信息
      currentVideoUrl: "",
      // 当前视频的路径
      isError: false // 视频加载错误状态

    };
  },
  mounted: function mounted() {
    // 获取路由参数中的id，找到对应的视频
    var videoId = parseInt(this.$route.params.id);
    var targetVideo = this.videoList.find(function (item) {
      return item.id === videoId;
    });

    if (targetVideo) {
      this.currentVideo = targetVideo;
      this.currentVideoUrl = targetVideo.videoUrl;
    } else {
      this.isError = true;
      console.error("未找到对应ID的视频");
    }
  },
  methods: {
    // 处理视频加载错误
    handleVideoError: function handleVideoError() {
      this.isError = true;
    }
  }
};